import React from 'react'
import './Footer.css'
function Footer() {
    return (
        <div className="footer">
            Copyright © Invoicejet 2021
        </div>
    )
}

export default Footer